import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { GLOBAL_ADMIN } from 'garaje/utils/roles';
import {
  MANAGE_COMPANY_ADMIN_PERMISSIONS,
  MANAGE_LOCATION_ADMIN_PERMISSIONS,
  MANAGE_CONNECT_ADMIN_PERMISSIONS,
} from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

const CAN_VISIT_ROLES = [GLOBAL_ADMIN];

export default class GlobalAdminAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare authz: AuthzService;

  get canVisit(): boolean {
    if (this.featureFlags.isEnabled('role-assignment-authz-ui')) {
      return (
        this.authz.hasAllPermissionsAtCurrentCompany(MANAGE_COMPANY_ADMIN_PERMISSIONS) ||
        this.authz.hasAllPermissionsAtCurrentCompany(MANAGE_LOCATION_ADMIN_PERMISSIONS) ||
        this.authz.hasAllPermissionsAtCurrentCompany(MANAGE_CONNECT_ADMIN_PERMISSIONS)
      );
    }
    const isOnCorrectPlan = !!this.state.features?.canAccessGlobalOverview;
    const hasCorrectRoles = isPresent(_intersection(CAN_VISIT_ROLES, this.currentAdmin.roleNames));
    return hasCorrectRoles && isOnCorrectPlan;
  }
}
